import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import cypressIds from 'CypressId';

import { VehicleLookupContext } from 'Context/vehicleLookup';

import { DOCUMENT_CAPTURE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsDocumentCapture';
import { applyCypressData } from 'Utilities/index';
import { safeLocalStorage } from 'Utilities/storages';

import { DOCUMENT_CAPTURE_ROUTE_NAMES } from '../../DocumentCapture.helpers';
import LocalTexts from '../../DocumentCapture.texts.json';
import { DocumentCaptureOfferContext } from '../../DocumentCaptureContexts';
import DocumentCaptureButtons from '../../shared/DocumentCaptureButtons/DocumentCaptureButtons';

const LocalT = new MDText(LocalTexts.documentsSummary);

const SummaryButtons = () => {
  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);
  const { vrm } = vehicle || {};
  const { enquiryId } = useContext(DocumentCaptureOfferContext) || {};
  const hideStepperEnquiries = safeLocalStorage.getItem('hideStepper') || [];

  const confirmSummaryUrl = `/${vrm}/${DOCUMENT_CAPTURE_ROUTE_NAMES.CONFIRM_SALE_SUMMARY}`;

  const onClick = () => {
    DOCUMENT_CAPTURE_SNOW_PLOW_EVENTS.DOCUMENTS_SUMMARY_BACK_TO_OVERALL_SUMMARY(
      {
        buttonLabel: LocalT.translate('backToSummary') as string,
        url: confirmSummaryUrl,
      },
    );

    // Remove stepper if they go back to summary page
    if (!hideStepperEnquiries.includes(enquiryId)) {
      hideStepperEnquiries.push(enquiryId);
      safeLocalStorage.setItem('hideStepper', hideStepperEnquiries);
    }
  };

  return (
    <DocumentCaptureButtons>
      <Button
        fullWidth as={Link}
        {...{ onClick }}
        label={LocalT.translate('backToSummary')}
        to={confirmSummaryUrl}
        {...applyCypressData(cypressIds.buttons.backToSummary)}
      />
    </DocumentCaptureButtons>
  );
};

export default SummaryButtons;
